<template>
  <base-dropzone
    :id="id"
    v-slot="{ browse }"
    v-model="files"
    :accept="accept"
    :multiple="multiple"
    @invalid="$emit('invalid', $event)"
  >
    <label :for="id" class="bubble">
      <div>
        <v-row no-gutters justify="center" class="ma-10">
          <v-icon class="bubble-icon material-icons-outlined">
            cloud_upload
          </v-icon>
        </v-row>
        <div class="subtitle-2 grey--text">
          <v-row no-gutters justify="center">
            {{ prompt }}
          </v-row>
          <v-row no-gutters justify="center">OR</v-row>
        </div>
        <v-row justify="center" class="my-2">
          <action-button color="primary" @click="browse">
            Browse Files
          </action-button>
        </v-row>
      </div>
    </label>
  </base-dropzone>
</template>

<script>
import { v4 as uuid } from 'uuid';
import ActionButton from '@/components/Common/ActionButton';
import BaseDropzone from '@/components/Common/BaseDropzone';

export default {
  name: 'UploadPagePlaceholder',
  components: { ActionButton, BaseDropzone },
  props: {
    value: {
      type: [Array, File],
      default: null,
    },
    id: {
      type: String,
      default: () => `upload-page-placeholder-${uuid()}`,
    },
    prompt: {
      type: String,
      default: 'Drag & drop a file here',
    },
    accept: {
      type: Array,
      default: () => ['.ris', '.xml'],
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    files: {
      get: function () {
        return this.value;
      },
      set: function (files) {
        this.$emit('input', files);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.bubble {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 326px;
  height: 326px;
  background-color: #e9f0ff;
  border-radius: 50%;
  cursor: pointer;
}
.bubble-icon {
  color: #d1e1ff;
  transform: scale(4);
}
</style>
